module.exports = __webpack_public_path__ + "static/media/10_bill_nav.7791c14a.svg";